import { isEmpty } from "lodash";
import React, { useState } from "react";
import {Form } from "react-bootstrap";

function InterventionPrescription({prescriptionStore, setPrescriptionStore, medicine, setMedicine }) {

  const handleMedicineChange = (index, event) => {
    const { name, value } = event.target;
    const updatedMedicines = prescriptionStore.map((item, idx) =>
      idx === index ? { ...item, [name]: value } : item
    );
    setPrescriptionStore(updatedMedicines);
  };

  const handleAddMedicine = () => {
    setPrescriptionStore([...prescriptionStore, { ...medicine }]);
    setMedicine({
      prescription: "",
      dosage: "",
      comment: "",
      external:true
    });
  };

  const handleRemoveMedicine = (index) => {
    const updatedMedicines = prescriptionStore.filter(
      (_, idx) => idx !== index
    );
    setPrescriptionStore(updatedMedicines);
  };


  const renderMedicineInputs = () => {
    return prescriptionStore.map((item, index) => (
      <div key={index} className="d-flex justify-content-between gap-2">
        {["prescription","dosage", "comment"].map((fieldName) => (
          <Form.Group key={`${fieldName}-${index}`} className="mb-3">
            <Form.Control
              name={fieldName}
              value={item[fieldName]}
              onChange={(e) => handleMedicineChange(index, e)}
              placeholder={
                fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
              }
            />
          </Form.Group>
        ))}
        <button
          className="btn btn-danger h-75"
          onClick={() => handleRemoveMedicine(index)}
        >
          -
        </button>
      </div>
    ));
  };

  return (
    <div>
      <Form >
        {renderMedicineInputs()}
        <div className="d-flex justify-content-between gap-2">
          {["prescription", "dosage", "comment"].map((fieldName) => (
            <Form.Group key={`initial-${fieldName}`} className="mb-3">
              <Form.Control
                name={fieldName}
                value={medicine[fieldName]}
                onChange={(e) =>
                  setMedicine({ ...medicine, [fieldName]: e.target.value })
                }
                placeholder={
                  fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
                }
              />
            </Form.Group>
          ))}
          <button
            type="button"
            className="btn btn-info h-75"
            onClick={handleAddMedicine}
          >
            +
          </button>
        </div>
      </Form>
    </div>
  );
}

export default InterventionPrescription;
